import GlobalLayout from "./src/components/GlobalLayout"
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it

// import * as React from "react"
// import { ThemeProvider } from "@mui/material/styles"
// import { CssBaseline } from "@mui/material"
// import theme from "./src/theme"
// import "./src/styles/global.css"
// import { Provider } from "react-redux"
// import store from "./src/state/store"
// export const wrapRootElement = ({ element }) => (
//   <Provider store={store}>
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       {element}
//     </ThemeProvider>
//   </Provider>
// )

// gatsby-browser.js
import React from "react"
import { ThemeProvider, CssBaseline } from "@mui/material"
import theme from "./src/theme"
import { Provider } from "react-redux"
import store from "./src/state/store"
import "./src/styles/global.css"
import "regenerator-runtime/runtime"
import { WebSocketProvider } from "./src/websocket/webSocket"
import { GoogleOAuthProvider } from "@react-oauth/google"

export const wrapRootElement = ({ element }) => {
    return (
        <Provider store={store}>
            <GoogleOAuthProvider clientId={process.env.GATSBY_GOOGLE_CLIENT_ID}>
                <GlobalLayout>
                    <WebSocketProvider>
                        <ThemeProvider theme={theme}>
                            <CssBaseline />
                            {element}
                        </ThemeProvider>
                    </WebSocketProvider>
                </GlobalLayout>
            </GoogleOAuthProvider>
        </Provider>
    )
}
